import { cn } from "@/lib/utils";

export function EditIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[25px] w-6 text-white", className)}
      viewBox="0 0 24 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.51 19.045c-.791 0-1.392-.202-1.802-.608-.405-.4-.608-.99-.608-1.772v-8.4c0-.787.203-1.38.608-1.78.41-.401 1.01-.601 1.802-.601h7.778l-1.436 1.435H7.598c-.342 0-.603.09-.784.271-.18.176-.271.442-.271.799v8.152c0 .356.09.622.271.798.18.176.442.264.784.264h8.357a.812.812 0 00.615-.264c.166-.176.249-.442.249-.798v-6.182l1.443-1.436v7.742c0 .781-.196 1.372-.586 1.773-.386.405-.93.607-1.633.607H7.51zm2.761-4.9c-.083.035-.159.018-.227-.05-.068-.074-.085-.152-.051-.235l.659-1.45 6.658-6.658 1.12 1.106-6.665 6.658-1.494.63zm8.694-7.814l-1.12-1.121.563-.557a.757.757 0 01.476-.22.55.55 0 01.454.162l.19.197a.595.595 0 01.199.477.733.733 0 01-.213.49l-.55.572z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MoreIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[5px] w-4 text-white", className)}
      viewBox="0 0 16 5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 .5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        fill="currentColor"
      />
    </svg>
  );
}

export function OffensiveIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[25px] w-6 text-white", className)}
      viewBox="0 0 24 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.877 19.778a7.273 7.273 0 01-2.922-.593 7.633 7.633 0 01-2.417-1.634 7.796 7.796 0 01-1.634-2.417 7.273 7.273 0 01-.593-2.922c0-1.035.198-2.01.593-2.922a7.758 7.758 0 014.043-4.05 7.273 7.273 0 012.923-.594 7.29 7.29 0 012.93.593 7.733 7.733 0 012.416 1.64 7.645 7.645 0 011.64 2.41c.396.914.594 1.888.594 2.923 0 1.035-.198 2.01-.593 2.922a7.733 7.733 0 01-4.058 4.05 7.273 7.273 0 01-2.922.594zm0-1.494c.845 0 1.633-.157 2.366-.47a5.978 5.978 0 001.933-1.303 6.084 6.084 0 001.304-1.933 5.964 5.964 0 00.469-2.366 6.004 6.004 0 00-1.78-4.3 6.084 6.084 0 00-1.934-1.303 5.965 5.965 0 00-2.365-.469 5.99 5.99 0 00-2.366.469 6 6 0 00-1.926 1.304 6.123 6.123 0 00-1.297 1.94 5.946 5.946 0 00-.468 2.359c0 .845.156 1.633.468 2.366a6.144 6.144 0 001.297 1.933 5.999 5.999 0 004.3 1.773zm0-4.856c-.425 0-.645-.215-.66-.645l-.102-3.56a.657.657 0 01.198-.527.758.758 0 01.55-.205c.224 0 .41.071.556.213.146.136.215.31.205.52l-.117 3.56c-.01.429-.22.644-.63.644zm0 2.431a.896.896 0 01-.615-.227.763.763 0 01-.25-.578c0-.23.084-.42.25-.572a.88.88 0 01.615-.234.86.86 0 01.6.227.74.74 0 01.257.579.739.739 0 01-.257.578.877.877 0 01-.6.227z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ShareIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[25px] w-6 text-white", className)}
      viewBox="0 0 24 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.77 19.983c-.791 0-1.39-.2-1.794-.6-.406-.401-.608-.994-.608-1.78v-7.208c0-.78.202-1.372.608-1.772.405-.405 1.003-.608 1.794-.608h2v1.443H7.858c-.342 0-.603.09-.784.271-.176.176-.263.442-.263.798v6.951c0 .356.087.623.263.798.18.181.442.271.784.271h8.254c.337 0 .596-.09.777-.27.185-.176.278-.443.278-.799v-6.95c0-.357-.093-.623-.278-.799-.181-.18-.44-.271-.777-.271h-1.897V8.015h1.992c.791 0 1.39.203 1.795.608.405.4.608.991.608 1.773v7.206c0 .782-.203 1.373-.608 1.773-.405.405-1.003.608-1.794.608H7.77zm4.219-5.838a.673.673 0 01-.484-.197.64.64 0 01-.197-.469V6.104l.058-1.092-.461.535-1.026 1.099a.58.58 0 01-.454.197.616.616 0 01-.432-.16.576.576 0 01-.168-.426c0-.156.06-.3.183-.432l2.46-2.366a.89.89 0 01.264-.183.667.667 0 01.513 0 .812.812 0 01.257.183l2.46 2.366c.127.132.19.276.19.432 0 .171-.06.313-.182.425a.606.606 0 01-.425.161.594.594 0 01-.454-.197l-1.026-1.1-.454-.534.059 1.092v7.375a.63.63 0 01-.205.469.649.649 0 01-.476.197z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SpoilersIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[25px] w-6 text-white", className)}
      viewBox="0 0 24 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.497 20.378c-.298 0-.53-.095-.696-.285-.161-.19-.242-.45-.242-.777v-1.801h-.3c-.708 0-1.316-.137-1.824-.41a2.835 2.835 0 01-1.164-1.172c-.269-.513-.403-1.133-.403-1.86V8.388c0-.728.134-1.346.403-1.853a2.77 2.77 0 011.164-1.18c.513-.273 1.138-.41 1.875-.41h9.338c.738 0 1.36.137 1.868.41a2.76 2.76 0 011.172 1.18c.268.507.403 1.125.403 1.853v5.683c0 .728-.135 1.348-.403 1.86a2.77 2.77 0 01-1.172 1.173c-.508.273-1.13.41-1.868.41h-4.43l-2.506 2.219c-.249.22-.463.38-.644.483a1.076 1.076 0 01-.571.161zm.351-1.618l2.33-2.3c.15-.156.292-.259.424-.308a1.51 1.51 0 01.542-.08h4.468c.688 0 1.199-.171 1.53-.513.338-.347.506-.86.506-1.538V8.433c0-.674-.168-1.182-.505-1.524-.332-.346-.843-.52-1.531-.52H7.347c-.689 0-1.201.173-1.538.52-.332.342-.498.85-.498 1.524v5.588c0 .679.166 1.191.498 1.538.337.342.85.513 1.538.513h.908c.205 0 .354.046.447.139.097.088.146.242.146.461v2.088zm3.135-6.314c-.425 0-.645-.215-.66-.644l-.102-3.56a.656.656 0 01.198-.527.758.758 0 01.55-.205c.224 0 .41.07.556.212.146.137.215.31.205.52l-.117 3.56c-.01.43-.22.644-.63.644zm0 2.432a.897.897 0 01-.615-.227.763.763 0 01-.25-.579c0-.23.084-.42.25-.571a.88.88 0 01.615-.234.86.86 0 01.6.227.738.738 0 01.257.578.739.739 0 01-.256.579.877.877 0 01-.601.227z"
        fill="currentColor"
      />
    </svg>
  );
}
